import z from "zod";

import { DocumentMetadataSchema as canvasMetadataSchema } from "../api-types";
import { type Env } from "../http/Env";
import { graphqlRequest } from "./graphqlRequest";

export interface QueryCanvasMetadataRequestOptions {
	canvasID: string;
	env: Env;
	fetch: (input: RequestInfo | URL, init?: RequestInit) => Promise<Response>;
	authorizationHeader: string | undefined;
}

export function queryCanvasMetadata({
	canvasID,
	env,
	fetch,
	authorizationHeader,
}: QueryCanvasMetadataRequestOptions): Promise<QueryCanvasMetadataResponse> {
	return graphqlRequest({
		env,
		fetch,
		authorizationHeader,
		query: queryCanvasMetadataOperation(canvasID),
		responseSchema: queryCanvasMetadataResponseSchema,
	});
}

const queryCanvasMetadataResponseSchema = z.object({ canvasMetadata: canvasMetadataSchema });
export type QueryCanvasMetadataResponse = z.infer<typeof queryCanvasMetadataResponseSchema>;

const queryCanvasMetadataOperation = (id: string) => ({
	operationName: "CanvasMetadata",
	query: `
	query CanvasMetadata($id: ID!) {
		canvasMetadata(id: $id) {
		  archived
		  archivedAt
		  atlasUserToken
		  created
		  id
		  organizationID
		  isTemplate
		  owner
		  pagesMetadata {
			archived
			authorID
			canvasID
			id
			created
			slug
			title
			updated
			parentPageID
		  }
		  pinnedAt
		  sharedName {
			sharedName
			organizationID
			namespace
		  }
		  title
		  type
		  updated
		  updatedBy
		  latestVersion
		}
	  }`,
	variables: { id },
});
